import { Injectable } from '@angular/core';
import { MatBottomSheet, MatBottomSheetConfig, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ComponentType } from '@angular/cdk/portal';

@Injectable()
export class MobilePopoverService {
  constructor(private bottomSheet: MatBottomSheet) {}

  open<T, D = any, R = any>(component: ComponentType<T>, config?: MatBottomSheetConfig<D>): MatBottomSheetRef<T, R> {
    const bottomSheetRef = this.bottomSheet.open(component, { ...config, panelClass: 'mobile-popover' });

    return bottomSheetRef;
  }

  openFullScreen<T, D = any, R = any>(
    component: ComponentType<T>,
    config?: MatBottomSheetConfig<D>
  ): MatBottomSheetRef<T, R> {
    const bottomSheetRef = this.bottomSheet.open(component, {
      ...config,
      disableClose: true,
      panelClass: ['mobile-popover', '__full-screen']
    });

    return bottomSheetRef;
  }
}
